import React from 'react'

// eslint-disable-next-line import/prefer-default-export
export function ArrowIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clipPath="url(#clip0_5058_74)">
        <path d="M2.8125 9H15.1875" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M10.125 3.9375L15.1875 9L10.125 14.0625"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5058_74">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
